import { useMemo } from 'react';
import { getSeries, isKpiShare } from '@utils/TableUtils';
import { GrowthTypes, KpiDropdownOption } from '@data-visualization/performance-segment-chart/Types';
import { LeaderboardKpi } from '@models/Products';
import {
  calculateChartScales,
  ChartScales,
} from '@data-visualization/performance-segment-mulitple-chart/hooks/UsePerformanceSegmentMultipleChartScales';

export const useProductsSegmentMultipleChartScales = (
  topSellingProductsContent: LeaderboardKpi[],
  selectedGrowthType: GrowthTypes,
  selectedKpi: KpiDropdownOption,
): ChartScales => {
  return useMemo<ChartScales>(() => {
    const series = getSeries(topSellingProductsContent, selectedKpi.value, selectedGrowthType, isKpiShare);
    return calculateChartScales(series[0].data);
  }, [topSellingProductsContent, selectedGrowthType, selectedKpi]);
};
